import React from "react";

import {
    FaChartLine,
} from "react-icons/fa";

import {
    formatDashboardDate,
} from "../utils/dashboardFormatters";


const DashboardHeader = ({
    lastUpdated,
    filter = {},
}) => {

    return (

        <div className="dashboard-page-header">

            <div className="dashboard-header-left">

                <div className="dashboard-header-icon">

                    <FaChartLine />

                </div>


                <div>

                    <span className="dashboard-page-eyebrow">
                        BUSINESS INTELLIGENCE
                    </span>


                    <h1>
                        Business Dashboard
                    </h1>


                    <p>
                        Sales, website orders, payments,
                        customers, employees and operations
                        in one quick view.
                    </p>

                </div>

            </div>


            <div className="dashboard-header-right">

                {
                    filter?.fromDate &&
                    filter?.toDate && (

                        <div className="dashboard-header-period">

                            <span>
                                Selected Period
                            </span>


                            <strong>

                                {
                                    formatDashboardDate(
                                        filter.fromDate
                                    )
                                }

                                {" - "}

                                {
                                    formatDashboardDate(
                                        filter.toDate
                                    )
                                }

                            </strong>

                        </div>

                    )
                }


                {
                    lastUpdated && (

                        <div className="dashboard-last-updated">

                            <span>
                                Last updated
                            </span>


                            <strong>

                                {
                                    new Date(
                                        lastUpdated
                                    )
                                        .toLocaleTimeString(
                                            "en-IN",
                                            {
                                                hour:
                                                    "2-digit",

                                                minute:
                                                    "2-digit",
                                            }
                                        )
                                }

                            </strong>

                        </div>

                    )
                }

            </div>

        </div>

    );

};


export default DashboardHeader;